<!-- 用户交互弹出信息 -->
<template>
    <v-snackbar v-model="m_showTip" top elevation="24" :timeout="1500" :color="m_TipColor" vertical>
        <v-icon v-if="m_TipType == 0">mdi-information-outline</v-icon>
        <v-icon v-if="m_TipType == 1">mdi-checkbox-marked-circle-outline</v-icon>
        <v-icon v-if="m_TipType == 2">mdi-alert-octagram-outline</v-icon>
        {{ m_TipMsg }}
        <v-btn text @click="m_showTip = false" icon>
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store";
export default {
    name: "PopUp",
    data: () => ({
        m_showTip: false,
        m_TipMsg: "",
        m_TipType: 0,
        drawer: false,
    }),
    computed: Object.assign(
        mapState({
            user: state => state.user,
            showTip: "showTip",
            TipMsg: "TipMsg",
            TipType: "TipType",
        }),
        {
            m_TipColor() {
                return this.m_TipType == 0
                    ? "info"
                    : this.m_TipType == 1
                    ? "success"
                    : this.m_TipType == 3
                    ? "warning"
                    : "error";
            },
        }
    ),

    watch: {
        showTip: function(newVal) {
            this.m_showTip = newVal;
        },
        TipMsg: function(newVal) {
            this.m_TipMsg = newVal;
        },
        TipType: function(newVal) {
            this.m_TipType = newVal;
        },
        m_showTip: function(newVal) {
            if (newVal == false) {
                store.commit("HIDE_TIP");
            }
        },
    },
};
</script>
